// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/practice/styles/Practice.scss
// module id = 1473
// module chunks = 0